export const TEMPLATE_AGE_TYPES = ["young","mid-age","mature"];
export const TEMPLATE_FORM_TYPES = ["round", "square", "triangle"];
export const TEMPLATE_EMBRASURES_TYPES = ["open","closed"];
export const TEMPLATE_INCISAL_EDGE_TYPES = ["round","square"];
export const TEMPLATE_BUCAL_SURFACE_TYPES = ["round","flat"];
export const CHANNEL_TYPES = [ "IPHONE", "IPAD", "MAC"];
